'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxFileNameLength = 30;
function truncateFileName(fileName) {
  if (!fileName || fileName.length <= maxFileNameLength) return fileName;

  var extension = void 0;
  var extensionStart = fileName.lastIndexOf('.');
  if (extensionStart > -1) {
    extension = fileName.substring(extensionStart);
  }

  return fileName.substring(0, maxFileNameLength) + '...' + extension;
}

var FeedItemAttachment = function FeedItemAttachment(props) {
  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'a',
      { className: 'feed-attachment', href: '', onClick: function onClick(e) {
          e.preventDefault();
          if (props.onAttachmentClick) {
            props.onAttachmentClick(props.attachmentId);
          }
        } },
      truncateFileName(props.fileName)
    )
  );
};

FeedItemAttachment.propTypes = {
  attachmentId: _react2.default.PropTypes.string.isRequired,
  fileName: _react2.default.PropTypes.string.isRequired,
  onAttachmentClick: _react2.default.PropTypes.func
};

exports.default = FeedItemAttachment;